import type { CohortFilters as CF } from "../lib/types";

const FILTER_DEFS: {
  key: keyof CF;
  label: string;
  options: { value: string; label: string }[];
}[] = [
  {
    key: "residency",
    label: "Residency",
    options: [
      { value: "resident", label: "Resident" },
      { value: "diaspora", label: "Diaspora" },
    ],
  },
  {
    key: "age_bracket",
    label: "Age",
    options: [
      { value: "18-25", label: "18–25" },
      { value: "26-40", label: "26–40" },
      { value: "41-60", label: "41–60" },
      { value: "60+", label: "60+" },
    ],
  },
  {
    key: "region_lebanon",
    label: "Region (in Lebanon)",
    options: [
      { value: "beirut", label: "Beirut" },
      { value: "mount_lebanon", label: "Mount Lebanon" },
      { value: "north", label: "North" },
      { value: "south", label: "South" },
      { value: "beqaa", label: "Beqaa" },
      { value: "akkar", label: "Akkar" },
    ],
  },
  {
    key: "region_diaspora",
    label: "Region (diaspora)",
    options: [
      { value: "americas", label: "Americas" },
      { value: "europe", label: "Europe" },
      { value: "gcc", label: "GCC" },
      { value: "africa", label: "Africa" },
      { value: "asia_oceania", label: "Asia/Oceania" },
    ],
  },
  {
    key: "sect",
    label: "Sect (optional, anonymous)",
    options: [
      { value: "maronite", label: "Maronite" },
      { value: "sunni", label: "Sunni" },
      { value: "shia", label: "Shia" },
      { value: "druze", label: "Druze" },
      { value: "greek_orthodox", label: "Greek Orthodox" },
      { value: "greek_catholic", label: "Greek Catholic" },
      { value: "armenian", label: "Armenian" },
      { value: "other_christian", label: "Other Christian" },
      { value: "other", label: "Other" },
      { value: "prefer_not_to_say", label: "Prefer not to say" },
    ],
  },
];

export default function CohortFilters({
  value,
  onChange,
}: {
  value: CF;
  onChange: (v: CF) => void;
}) {
  function setKey(key: keyof CF, v: string) {
    onChange({ ...value, [key]: v || undefined });
  }
  function clearAll() {
    onChange({});
  }
  const hasAny = Object.values(value).some(Boolean);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-medium">Cohort filters</h3>
        {hasAny && (
          <button onClick={clearAll} className="text-xs text-muted underline">
            clear
          </button>
        )}
      </div>
      {FILTER_DEFS.map((def) => (
        <div key={def.key}>
          <label className="label">{def.label}</label>
          <select
            value={value[def.key] ?? ""}
            onChange={(e) => setKey(def.key, e.target.value)}
            className="input"
          >
            <option value="">(any)</option>
            {def.options.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
      ))}
      <p className="text-xs text-muted">
        When any filter is applied, individual question breakdowns are suppressed below
        10 votes for privacy.
      </p>
    </div>
  );
}
